import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { styled, Button, Container, Typography, Link as MUILink } from "@mui/material";

import { AppRoutes } from "types";
import { getEnvVarsStorage } from "helpers";
import { getAdditionalLinks } from "./config";

const PolicyWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  padding: "0.5rem 0",
  backgroundColor: theme.palette.grey[100],
}));

const PolicyDialog = () => {
  const { t } = useTranslation("common");
  const [agreed, setAgreed] = useState<boolean>(false);
  const envs = getEnvVarsStorage();

  useEffect(() => {
    setAgreed(localStorage.getItem("policy-agreed") === "true");
  }, []);

  const toggle = () => {
    localStorage.setItem("policy-agreed", "true");
    setAgreed(true);
  };
  const { termsLink, privacyLink } = getAdditionalLinks(envs);
  return agreed ? null : (
    <PolicyWrapper>
      <Container sx={{ display: "flex", alignItems: "center" }}>
        <Typography>
          By using this website you agree to our &nbsp;
          <a style={{ color: envs?.primaryColor }} href={privacyLink} target="_blank" rel="noopener noreferrer">
            {t("nav.privacyPolicy")}
          </a> &nbsp;
          and &nbsp;
          <a style={{ color: envs?.primaryColor }} href={termsLink} target="_blank" rel="noopener noreferrer">
            {t("nav.termsConditions")}
          </a>
        </Typography>
        <Button variant="contained" color="secondary" size="small" sx={{ ml: 1 }} onClick={toggle}>
          Got it
        </Button>
      </Container>
    </PolicyWrapper>
  );
};

export default PolicyDialog;
